import React, { useEffect, useId, useRef, useState } from 'react';
import { ChevronDown } from 'lucide-react';

// Navigation disclosure: normal buttons keep native keyboard order, including
// on touch screens. Dismissal restores focus only when Escape is used.
export default function WorkspaceMenu({ label, active = false, count = 0, children }) {
  const [open, setOpen] = useState(false);
  const root = useRef(null);
  const trigger = useRef(null);
  const id = useId();
  useEffect(() => {
    if (!open) return undefined;
    const outside = event => { if (!root.current?.contains(event.target)) setOpen(false); };
    const escape = event => {
      if (event.key === 'Escape') { setOpen(false); trigger.current?.focus(); }
    };
    document.addEventListener('pointerdown', outside);
    document.addEventListener('keydown', escape);
    return () => {
      document.removeEventListener('pointerdown', outside);
      document.removeEventListener('keydown', escape);
    };
  }, [open]);
  return <div className="workspace-menu" ref={root}>
    <button type="button" ref={trigger} aria-expanded={open} aria-controls={id}
      className={active ? 'workspace-menu-active' : ''} onClick={() => setOpen(value => !value)}>
      {label}{count > 0 && <span className="embedded-nav-count">{count}</span>}<ChevronDown size={13} aria-hidden="true" />
    </button>
    {open && <div className="workspace-menu-list" id={id} role="group" aria-label={label}
      onClick={event => { if (event.target.closest('button')) setOpen(false); }}>
      {children}
    </div>}
  </div>;
}
